import { render } from "./KSChangeClusterOwner.vue?vue&type=template&id=fc63a0ce"
import script from "./KSChangeClusterOwner.vue?vue&type=script&lang=js"
export * from "./KSChangeClusterOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__